import Const from 'constants';
import SuffixMarker from 'services/simplex/suffix-marker';

const suffix = Const.LP_ITEM_DELIMITER + Const.LP_RANDOM_TEAMS_STACK_SUFFIX;

const RandomTeamsStackMarker = {
    suffix,
    ...SuffixMarker,
};

export default RandomTeamsStackMarker;
